export function groupRegistrations(rows) {
  const groups = new Map();
  for (const row of rows) {
    // Student IDs link the paired exams; identical names may belong to different students.
    const key = row.student_id ?? row.registration_id;
    if (!groups.has(key)) groups.set(key, {
      id: key,
      name: row.student_name,
      offeringId: row.offering_id,
      label: row.label,
      canEdit: row.can_edit_registration !== false,
      exams: []
    });
    const group = groups.get(key);
    group.canEdit = group.canEdit && row.can_edit_registration !== false;
    group.exams.push(row);
  }
  return [...groups.values()].sort((a, b) => String(a.name ?? '').trim().localeCompare(String(b.name ?? '').trim(), 'en', { sensitivity: 'base' }) || String(a.id).localeCompare(String(b.id))).map(group => ({ ...group, exams: [...group.exams].sort((a, b) => (a.exam_type === 'aural') - (b.exam_type === 'aural')) }));
}
export function examStatus(row) {
  return row.revoked ? 'Revoked' : row.used ? 'Completed' : 'Ready to take';
}
export function examInfo(group, teacherName) {
  return [
    `Hi ${group.name},`, '',
    'Here are your Registration IDs and Passcodes to take the Student Day exams online.', '',
    ...group.exams.flatMap(row => {
      const type = row.exam_type === 'aural' ? 'Aural' : 'Theory';
      const level = String(row.level ?? '').replace(/^level\s+/i, '');
      return [
        /^primary$/i.test(level) ? `${type} Primary` : `${type} Level ${level}`,
        `RegistrationID: ${row.registration_id}`,
        `Passcode: ${row.passcode}`, ''
      ];
    }),
    'If you run into any issues logging in, please email music@liontheory.com', '',
    'Good luck!', '',
    teacherName
  ].join('\n');
}
